<template>
  <!-- 第三步：管理系统上云情况 -->
  <div class="thirdStep">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="200px"
      class="form-wrap"
      :disabled="!ifEdit"
    >
      <div class="step-title">办公协同（OfficeCollaboration）：</div>
      <el-form-item label="工作文件存储和备份上云(个)" prop="oaFile">
        <el-input-number v-model="form.oaFile" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="视频会议系统上云(个)" prop="oaVideo">
        <el-input-number v-model="form.oaVideo" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="办公上云(个)" prop="oaOffice">
        <el-input-number v-model="form.oaOffice" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="安保上云(个)" prop="oaSecuruty">
        <el-input-number v-model="form.oaSecuruty" :min="0" :max="1" />
      </el-form-item>
      <div class="step-title">人力资源管理（Human Resource Management）：</div>
      <el-form-item label="人力资源规划上云(个)" prop="humanPlan">
        <el-input-number v-model="form.humanPlan" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="招聘管理上云(个)" prop="humanRecruit">
        <el-input-number v-model="form.humanRecruit" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="培训管理上云(个)" prop="humanTraning">
        <el-input-number v-model="form.humanTraning" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="绩效管理上云(个)" prop="humanPerformance">
        <el-input-number v-model="form.humanPerformance" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="薪酬管理上云(个)" prop="humanSalary">
        <el-input-number v-model="form.humanSalary" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="劳动关系管理上云(个)" prop="humanReleation">
        <el-input-number v-model="form.humanReleation" :min="0" :max="1" />
      </el-form-item>
      <div class="step-title">财务管理（Financial Management）：</div>
      <el-form-item label="税务管理上云(个)" prop="fmTax">
        <el-input-number v-model="form.fmTax" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="报销管理上云(个)" prop="fmExpense">
        <el-input-number v-model="form.fmExpense" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="资产管理上云(个)" prop="fmAssets">
        <el-input-number v-model="form.fmAssets" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="成本核算管理上云(个)" prop="fmCost">
        <el-input-number v-model="form.fmCost" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="资金管理上云(个)" prop="fmMoney">
        <el-input-number v-model="form.fmMoney" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="总账报表管理上云(个)" prop="fmTotal">
        <el-input-number v-model="form.fmTotal" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="其他类型管理使用上云(个)" prop="managerOther">
        <el-input-number v-model="form.managerOther" :min="0"  />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { thirdSave, thirdInfo } from "@/utils/interface";
const form = () => {
  return {
    oaFile: "", // 工作文件存储和备份上云数量
    oaVideo: "", // 视频会议系统上云数量
    oaOffice: "", // 办公上云数量
    oaSecuruty: "", // 安保上云数量
    humanPlan: "", // 人力资源基础信息
    humanRecruit: "", // 招聘管理数量
    humanTraning: "", // 培训管理数量
    humanPerformance: "", // 绩效管理数量
    humanSalary: "", // 薪酬管理数量
    humanReleation: "", // 劳动关系管理数量
    fmTax: "", // 税务管理数量
    fmExpense: "", // 报销管理数量
    fmAssets: "", // 资产管理数量
    fmCost: "", // 成本核算管理数量
    fmMoney: "", // 资金管理数量
    fmTotal: "", // 总账报表管理
    managerOther: "" //其他类型管理使用数量
  };
};
export default {
  name: "",
  components: {},
  props: {
    registerId: {
      type: String
    },
    ifEdit: {
      type: Boolean,
      default: false
    } // 是否是可编辑状态，即上云申请只保存未提交,false为不可编辑，true为可编辑
  },
  data() {
    const rules = () => {
      return {
        oaFile: [{ required: true, message: "请输入数量", trigger: "blur" }],
        oaVideo: [{ required: true, message: "请输入数量", trigger: "blur" }],
        oaOffice: [{ required: true, message: "请输入数量", trigger: "blur" }],
        oaSecuruty: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        humanPlan: [{ required: true, message: "请输入数量", trigger: "blur" }],
        humanRecruit: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        humanTraning: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        humanPerformance: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        humanSalary: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        humanReleation: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        fmTax: [{ required: true, message: "请输入数量", trigger: "blur" }],
        fmExpense: [{ required: true, message: "请输入数量", trigger: "blur" }],
        fmAssets: [{ required: true, message: "请输入数量", trigger: "blur" }],
        fmCost: [{ required: true, message: "请输入数量", trigger: "blur" }],
        fmMoney: [{ required: true, message: "请输入数量", trigger: "blur" }],
        fmTotal: [{ required: true, message: "请输入数量", trigger: "blur" }],
        managerOther: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ]
      };
    };
    return {
      form: form(),
      rules: rules(),
      uuid: "" // 当前条保存后的uuid
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.uuid) {
      this.getThirdInfo();
    }
  },
  methods: {
    /* 第三步保存 */
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            userUuid: this.$store.state.isUsermessage.uuid,
            registerId: this.registerId,
            uuid: this.uuid,
            ...this.form
          };
          thirdSave(params).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.uuid = res.data.uuid;
              this.$parent.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        }
      });
    },
    /* 第三步详情 */
    getThirdInfo() {
      thirdInfo(this.$route.query.uuid).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
        } else {
          this.form = form();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.thirdStep {
  .step-title {
    position: relative;
    font-size: 14px;
    margin: 20px 0;
    &::before {
      position: absolute;
      content: "";
      width: 4px;
      height: 4px;
      border-radius: 50%;
      .bc();
      top: 50%;
      transform: translateY(-50%);
      left: -10px;
    }
  }
  /deep/ .el-form-item {
    width: 525px;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  /deep/ .el-input-number {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/component/thirdStep.vue